<app-navbar>
</app-navbar>

<span bcShowIfPrivilegeDynamic="Camps.campsCanView">
    <app-side-menu></app-side-menu>
</span>

<div class="main-container">
    <router-outlet></router-outlet>
    <bcu-alert></bcu-alert>
    <bcu-spinner></bcu-spinner>
    <bcu-modal></bcu-modal>
</div>

<horizon-app-version-footer backgroundColor="#F6FAFF" strokeColor="#E9EEF2"></horizon-app-version-footer>
